export default __webpack_public_path__ + "static/media/hbs-blk-banner-3.cf02afda.jpg";